// components/auth/PublicRoute.jsx
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from '../components/navigation/Navbar';
import Footer from '../components/navigation/Footer';

const ConditionalNavbar = () => {
  const location = useLocation();
  const isOnePagerRoute = location.pathname === '/OnePager';
  const isPreviewRoute = location.pathname.startsWith('/preview/');
  const isPublishedSiteRoute = location.pathname.startsWith('/site/');
  const FiveMinuteWebsiteRoute = location.pathname === '/5MinuteWebsite';
  const WebBuilderTenSites = location.pathname === '/build-10-websites';
  const WebBuilder99StartUp = location.pathname === '/WebBuilder99StartUp';
  if (isOnePagerRoute || isPreviewRoute || isPublishedSiteRoute || FiveMinuteWebsiteRoute || WebBuilderTenSites || WebBuilder99StartUp) {
    return null;
  }

  return <Navbar />;
};

const ConditionalFooter = () => {
  const location = useLocation();
  const isOnePagerRoute = location.pathname === '/OnePager';
  const isPreviewRoute = location.pathname.startsWith('/preview/');
  const isPublishedSiteRoute = location.pathname.startsWith('/site/');
  const FiveMinuteWebsiteRoute = location.pathname === '/5MinuteWebsite';
  const WebBuilderTenSites = location.pathname === '/build-10-websites';
  const WebBuilder99StartUp = location.pathname === '/WebBuilder99StartUp';
  if (isOnePagerRoute || isPreviewRoute || isPublishedSiteRoute || FiveMinuteWebsiteRoute || WebBuilderTenSites || WebBuilder99StartUp) {
    return null;
  }

  return <Footer />;
};

const PublicRoute = () => {
  return (
    <>
      <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
        <ConditionalNavbar />
        <div style={{ flex: 1 }}>
          <Outlet />
        </div>
        <ConditionalFooter />
      </div>
    </>
  );
};

export default PublicRoute;
